import moment from "moment";

const dateParser = (rawDate) => ({
  value: rawDate ? moment(rawDate) : rawDate
});

const calculateAge = (dob) => moment().diff(moment(dob, "YYYY-MM-DD"), "years");

const getNamesFromFullName = (fullName, includeMiddleName = true) => {
  if (!fullName) {
    return {};
  }
  let firstName;
  let middleName;
  let lastName;
  if (fullName.includes(",")) {
    // Case where the name is in the format of "lastName, firstName"
    const rawParts = fullName.split(",");

    if (rawParts.length === 2) {
      lastName = rawParts[0].trim();
      firstName = rawParts[1].trim();
    } else {
      // 3+ comma parts (e.g. "Nagpal, MD, Sunil"): last part is firstName,
      // everything before joins into lastName. Mirrors the space-separated
      // rule that keeps trailing tokens like "MD" inside lastName for
      // "AMBER MASSEY BORDEN MD".
      const parts = rawParts.map((p) => p.trim()).filter(Boolean);
      if (parts.length >= 2) {
        firstName = parts[parts.length - 1];
        lastName = parts.slice(0, -1).join(" ");
      } else if (parts.length === 1) {
        lastName = parts[0];
      }
    }
  } else {
    const nameParts = fullName.split(" ");

    if (nameParts?.length === 1) {
      firstName = nameParts[0];
    } else if (nameParts?.length === 2) {
      firstName = nameParts[0];
      lastName = nameParts[1];
    } else if (nameParts?.length === 3 && includeMiddleName) {
      // 3 words with middleName: "firstName middleName lastName"
      firstName = nameParts[0];
      middleName = nameParts[1];
      lastName = nameParts[2];
    } else if (nameParts?.length >= 3) {
      // 3+ words: split in half
      const midpoint = Math.floor(nameParts.length / 2);
      const isOdd = nameParts.length % 2 === 1;

      if (includeMiddleName && isOdd) {
        // Odd count with middleName: first half, absolute middle, last half
        firstName = nameParts.slice(0, midpoint).join(" ");
        middleName = nameParts[midpoint];
        lastName = nameParts.slice(midpoint + 1).join(" ");
      } else {
        // Even count or no middleName: just split in half
        firstName = nameParts.slice(0, midpoint).join(" ");
        lastName = nameParts.slice(midpoint).join(" ");
      }
    }
  }

  return { firstName, middleName, lastName };
};

export { dateParser, getNamesFromFullName, calculateAge };
